export const introDialogue = {
  type: "dialogue",
  nextSequence: "dashboardTutorial",
  orbPosition: {
    left: "50%",
    top: "25%",
    scale: 2,
  },
  steps: [
    {
      id: "step1",
      text: `... ... ...`,
      selector: "[data-driver='next-button']",
      title: "Initializing contact...",
      description: "Click next button to start the tutorial.",
      side: "top",
      align: "center",
    },
    {
      id: "step2",
      text: `Contact established... 


	  Ah. You made it. I was beginning to wonder if any would answer the call.`,
    },
    {
      id: "step3",
      text: `Welcome, Traveler - to The Infinity.
			A realm once teeming with balance and power... now on the brink of collapse.`,
    },
    {
      id: "step4",
      text: `Time fractures. Energy fades. And the once-unbreakable flow between realities is crumbling.`,
    },
    {
      id: "step5",
      text: `They called me I.O. - the Infinity Orb. I was created to protect this place, to guide new Travelers like you. But something has disturbed the core...`,
    },
    {
      id: "step6",
      text: `The characters, the decks, the monsters - they're not just data. They're living echoes of this fractured world... and they need you.`,
    },
    {
      id: "step7",
      text: `I've scanned your energy... you've got a funny name.
	  
	  But hey - I've seen worse. There was a Traveler once named... "BeefCheeks42."`,
    },
    {
      id: "step8",
      text: `Anyway. You've got potential. And with your help, we might just have a shot at restoring balance.`,
    },
    {
      id: "step9",
      text: `But first... you'll need to learn how to play, survive, and win!`,
    },
    {
      id: "step10",
      text: `Let me show you how to wield your deck, command your cards, and unleash your strength.`,
    },
    {
      id: "step11",
      text: `Time is short. And the Infinity waits for no one.`,
    },
  ],
};

export const dashboardTutorial = {
  type: "dashboard",
  nextSequence: null,
  orbPosition: {
    right: "8%",
    top: "18%",
    scale: 1.2,
  },
  steps: [
    {
      id: "avatar-dialog",
      text: `Ok, I know you're excited to play! but... 

	  First, let me show you around at least.`,
    },
    {
      id: "settings",
      text: "...",
      selector: "[data-driver='dashboard-settings']",
      title: "Settings",
      description:
        "Here is where you access your settings, audio, account, and preferences.",
      side: "bottom",
      align: "start",
    },
    {
      id: "tokens",
      text: "...",
      selector: "[data-driver='dashboard-tokens']",
      title: "Infinity Tokens",
      description:
        "This shows your Infinity Token balance... it'll help you keep track.",
      side: "bottom",
      align: "start",
    },
    {
      id: "rewards",
      text: "...",
      selector: "[data-driver='dashboard-rewards']",
      title: "Rewards",
      description:
        "Oh, and this is where your rewards appear when they're ready to br claimed!",
      side: "bottom",
      align: "start",
    },
    {
      id: "wallet",
      text: "...",
      selector: "[data-driver='dashboard-wallet']",
      title: "Wallet",
      description: "Use Wallet to view your battle wallet balance.",
      side: "bottom",
      align: "start",
    },
    {
      id: "leaders",
      text: "...",
      selector: "[data-driver='dashboard-leaders']",
      title: "Leaders",
      description:
        "And here's where you check current player rankings and leaderboard standings.",
      side: "bottom",
      align: "start",
    },
    {
      id: "level",
      text: "...",
      selector: "[data-driver='dashboard-level']",
      title: "Level",
      description: "Track your level and XP progress here.",
      side: "right",
      align: "start",
    },
    {
      id: "shop",
      text: "...",
      selector: "[data-driver='dashboard-shop']",
      title: "Shop",
      description:
        "Use this to navigate to the Shop to browse packs, cards, and other cool items.",
      side: "right",
      align: "start",
    },
    {
      id: "buys",
      text: "...",
      selector: "[data-driver='dashboard-buys']",
      title: "Purchases",
      description: "Review and open purchased items here.",
      side: "right",
      align: "start",
    },
    {
      id: "emotes",
      text: "...",
      selector: "[data-driver='dashboard-emotes']",
      title: "Emotes",
      description:
        "Manage your emotes from this menu item. You.. so you can.. express yourself hehe.",
      side: "right",
      align: "start",
    },
    {
      id: "season",
      text: "...",
      selector: "[data-driver='dashboard-season']",
      title: "Season",
      description: "Open seasonal content, events, and pass progress.",
      side: "right",
      align: "start",
    },
    {
      id: "league",
      text: "...",
      selector: "[data-driver='dashboard-league']",
      title: "League",
      description:
        "Discover weekly ranked competitive content here. BUT you have to join an NFTeam first...",
      side: "left",
      align: "start",
    },
    {
      id: "nfteams",
      text: "...",
      selector: "[data-driver='dashboard-nfteams']",
      title: "NFTeams",
      description: "You can do that here!",
      side: "left",
      align: "start",
    },
    {
      id: "mail",
      text: "...",
      selector: "[data-driver='dashboard-mail']",
      title: "Mail",
      description: "Read system and player messages in Mail from here.",
      side: "left",
      align: "start",
    },
    {
      id: "friends",
      text: "...",
      selector: "[data-driver='dashboard-friends']",
      title: "Friends",
      description:
        "Find all of your friends here!.. you know.. If you have any that is hehe.",
      side: "left",
      align: "start",
    },
    {
      id: "referrals",
      text: "...",
      selector: "[data-driver='dashboard-referrals']",
      title: "Referrals",
      description: `Earn exclusice items by referring all of those... 'friends' you have. 
      
      But first you gotta hit level 25.`,
      side: "left",
      align: "start",
    },
    {
      id: "cards",
      text: "...",
      selector: "[data-driver='dashboard-cards']",
      title: "Cards",
      description:
        "View and inspect your card collection and build new decks from here.",
      side: "top",
      align: "center",
    },
    {
      id: "play",
      text: "...",
      selector: "[data-driver='dashboard-play']",
      title: "Play",
      description: "Start your main game flow from the PLAY button.",
      side: "top",
      align: "center",
    },
    {
      id: "how-to-play",
      text: "...",
      selector: "[data-driver='dashboard-how-to-play']",
      title: "How To Play",
      description: `Oh!... 
      
      One more thing!
      If you ever want a refresher, your How To Play videos live right here. You're all set to jump in.`,
      side: "top",
      align: "center",
    },
  ],
};
